@if (!readonly()) {
  <div class="upload-file w-full mx-2">
    <div class="mb-3">
      <div class="text-base leading-snug">
        {{ label() }}
      </div>
    </div>

    @if (listPosition() === 'above') {
      <ng-container [ngTemplateOutlet]="fileList"></ng-container>
    }

    @if (multiple() || controlValue.length === 0) {
      <button
        type="button"
        class="upload-dropzone flex min-h-44 w-full cursor-pointer flex-col items-center justify-center gap-5 rounded-[1.25rem] border-2 border-dashed border-[#c8b9bd] bg-[#fffafb] p-6 text-[#5a4b4f] transition"
        [class.drag-active]="dragActive"
        [disabled]="formDisabled()"
        [attr.aria-label]="'GENERAL.upload_area' | translate"
        (click)="!formDisabled() && fileInputRef().nativeElement.click()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <mat-icon class="h-12! w-12! text-5xl! text-[#ead5dc]">upload</mat-icon>
        <div class="flex flex-col items-center gap-1">
          <span class="text-center text-small text-secondary">
            {{ 'GENERAL.upload_drag_drop' | translate }}
          </span>
          <span class="text-center text-small text-secondary">
            Dimensione massima: {{ maxSize() / (1024 * 1024) }} MB
          </span>
          @if (controlValue.length > 0) {
            <span class="text-center text-small font-semibold text-[#245064]">
              {{ controlValue.length }}
              {{
                controlValue.length === 1 ? 'file allegato' : 'file allegati'
              }}
            </span>
          }
        </div>
        <span
          class="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-[#9f2759] px-5 text-base font-semibold text-white"
        >
          <mat-icon class="h-5! w-5! text-xl!">upload</mat-icon>
          {{
            (multiple() ? 'GENERAL.select_file' : 'GENERAL.select_file')
              | translate
          }}
        </span>
      </button>
    }

    @if (listPosition() === 'below') {
      <ng-container [ngTemplateOutlet]="fileList"></ng-container>
    }

    <ng-template #fileList>
      @if (controlValue.length > 0) {
        <div
          class="flex flex-col gap-2"
          [class.mt-4]="listPosition() === 'below'"
          [class.mb-4]="listPosition() === 'above'"
        >
          @for (
            item of controlValue;
            track item.nomeFile + 'index_' + i;
            let i = $index
          ) {
            <div
              class="file-row flex items-center gap-3 rounded-xl border border-[#e8dce0] bg-white px-4 py-2 text-[#2f2629]"
            >
              <mat-icon class="shrink-0 h-7! w-7! text-3xl! text-[#245064]">
                {{ fileIconName(i) }}
              </mat-icon>

              <button
                type="button"
                class="min-w-0 flex-1 cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap border-0 bg-transparent p-0 text-left text-[#245064]"
                [matTooltip]="'GENERAL.preview_file' | translate"
                [attr.aria-label]="'GENERAL.preview_file' | translate"
                (click)="previewFile(i)"
              >
                {{ item.nomeFile }}
              </button>

              <div class="ml-auto inline-flex shrink-0 items-center gap-1">
                <button
                  mat-icon-button
                  type="button"
                  [matTooltip]="'GENERAL.preview_file' | translate"
                  [attr.aria-label]="'GENERAL.preview_file' | translate"
                  (click)="previewFile(i)"
                >
                  <mat-icon>visibility</mat-icon>
                </button>
                @if (!formDisabled()) {
                  <button
                    mat-icon-button
                    type="button"
                    [matTooltip]="'GENERAL.remove_selected_file' | translate"
                    [attr.aria-label]="
                      'GENERAL.remove_selected_file' | translate
                    "
                    (click)="removeFile(i)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                }
                <mat-icon class="h-6! w-6! text-2xl! text-[#008a61]"
                  >check</mat-icon
                >
              </div>
            </div>
          }
        </div>
      }
    </ng-template>

    <input
      hidden
      type="file"
      [id]="id()"
      [name]="name()"
      [accept]="accept()"
      [multiple]="multiple()"
      [disabled]="formDisabled()"
      #fileInput
      (change)="onFileSelected($event)"
    />
  </div>
} @else {
  <div class="flex flex-col gap-2">
    @for (item of controlValue; track item.nomeFile; let i = $index) {
      <div class="inline-flex items-center gap-2">
        <mat-icon class="shrink-0 h-5! w-5! text-xl! text-[#245064]">
          {{ fileIconName(i) }}
        </mat-icon>
        <span class="text-small text-[#245064]">{{ item.nomeFile }}</span>
        <button
          mat-icon-button
          type="button"
          class="scale-75"
          [attr.aria-label]="'GENERAL.preview_file' | translate"
          (click)="previewFile(i)"
          [matTooltip]="'GENERAL.view_file' | translate"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </div>
    }
  </div>
}
